import React from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';
import { BPLeaderboard } from '../components/BPLeaderboard';

export const BrownlowPredictorLeaderboardProvider = ({ store, data }) => {
    return (
        <Provider store={store}>
            <BPLeaderboard {...data} />
        </Provider>
    );
};

BrownlowPredictorLeaderboardProvider.propTypes = {
    store: PropTypes.object.isRequired,
    data: PropTypes.object
};
